export default "__VITE_ASSET__b0E7fSK1__"